export function classNames(...values) {
  return values.filter(Boolean).join(" ");
}

export function cleanTemplateName(fileName = "") {
  // 移除扩展名、导入流水号和异常字符，得到适合界面展示的模板名称。
  return fileName
    .replace(/\uFFFD/g, "")
    .replace(/\.(docx?|pdf|html?)$/i, "")
    .replace(/_[0-9]{12,}$/i, "")
    .replace(/^\s+|\s+$/g, "");
}

export function formatBytes(bytes = 0) {
  // 按文件大小自动选择单位，在较小数值时保留一位小数兼顾可读性。
  const value = Number(bytes || 0);
  if (value < 1024) return value + " B";
  if (value < 1024 * 1024) return Math.round(value / 1024) + " KB";
  if (value < 1024 * 1024 * 1024) {
    return (value / (1024 * 1024)).toFixed(value >= 10 * 1024 * 1024 ? 0 : 1) + " MB";
  }
  return (value / (1024 * 1024 * 1024)).toFixed(1) + " GB";
}

export function formatDate(value) {
  if (!value) return "未记录";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function compactText(value = "", limit = 140) {
  const text = String(value).replace(/\s+/g, " ").trim();
  if (!text) return "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
}

export function roleLabel(role) {
  return {
    client: "客户端",
    expert: "专家端",
    platform: "平台端",
  }[role] || "客户端";
}
